var map = {
	"./account.route.js": "K6Sh",
	"./customer.route.js": "xwc/",
	"./main.route.js": "tv/E",
	"./order.route.js": "toA/",
	"./role.route.js": "UtVs",
	"./stores.route.js": "c6hw",
	"./system.route.js": "Ky6V"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "OOrP";


//////////////////
// WEBPACK FOOTER
// ./src/router/modules ^([\s\S])+\.route\.js$
// module id = OOrP
// module chunks = 12